export class CodigosPostales {

    public codigosPostalesMap = new Map();

    constructor() {
        this.rellenarCodigosPostales();
    }
    rellenarCodigosPostales(): void {
        this.codigosPostalesMap.set('41001', 'Sevilla');
        this.codigosPostalesMap.set('41002', 'Sevilla');
        this.codigosPostalesMap.set('41003', 'Sevilla');
        this.codigosPostalesMap.set('41004', 'Sevilla');
        this.codigosPostalesMap.set('41005', 'Sevilla');
        this.codigosPostalesMap.set('41006', 'Sevilla');
        this.codigosPostalesMap.set('41007', 'Sevilla');
        this.codigosPostalesMap.set('41008', 'Sevilla');
        this.codigosPostalesMap.set('41009', 'Sevilla');
        this.codigosPostalesMap.set('41010', 'Sevilla');
        this.codigosPostalesMap.set('41011', 'Sevilla');
        this.codigosPostalesMap.set('41012', 'Sevilla');
        this.codigosPostalesMap.set('41013', 'Sevilla');
        this.codigosPostalesMap.set('41014', 'Sevilla');
        this.codigosPostalesMap.set('41015', 'Sevilla');
        this.codigosPostalesMap.set('41016', 'Sevilla');
        this.codigosPostalesMap.set('41017', 'Sevilla');
        this.codigosPostalesMap.set('41018', 'Sevilla');
        this.codigosPostalesMap.set('41019', 'Sevilla');
        this.codigosPostalesMap.set('41020', 'Sevilla');
        this.codigosPostalesMap.set('41073', 'Dos Hermanas');
        this.codigosPostalesMap.set('41089', 'Dos Hermanas');
        this.codigosPostalesMap.set('41092', 'Sevilla');
        this.codigosPostalesMap.set('41100', 'Coria del Río');
        this.codigosPostalesMap.set('41110', 'Bollullos de la Mitación');
        this.codigosPostalesMap.set('41111', 'Almensilla');
        this.codigosPostalesMap.set('41120', 'Gelves');
        this.codigosPostalesMap.set('41130', 'La Puebla del Río');
        this.codigosPostalesMap.set('41140', 'Isla Mayor');
        this.codigosPostalesMap.set('41150', 'Isla Mayor');
        this.codigosPostalesMap.set('41200', 'Alcalá del Río');
        this.codigosPostalesMap.set('41200', 'Burguillos');
        this.codigosPostalesMap.set('41209', 'Alcalá del Río');
        this.codigosPostalesMap.set('41210', 'Guillena');
        this.codigosPostalesMap.set('41218', 'Guillena');
        this.codigosPostalesMap.set('41219', 'Guillena');
        this.codigosPostalesMap.set('41220', 'Gelves');
        this.codigosPostalesMap.set('41220', 'Burguillos');
        this.codigosPostalesMap.set('41230', 'Castilblanco de los Arroyos');
        this.codigosPostalesMap.set('41240', 'Almadén de la Plata');
        this.codigosPostalesMap.set('41250', 'El Real de la Jara');
        this.codigosPostalesMap.set('41300', 'La Rinconada');
        this.codigosPostalesMap.set('41309', 'La Rinconada');
        this.codigosPostalesMap.set('41310', 'Brenes');
        this.codigosPostalesMap.set('41318', 'Villaverde del Río');
        this.codigosPostalesMap.set('41319', 'Alcalá del Río');
        this.codigosPostalesMap.set('41320', 'Cantillana');
        this.codigosPostalesMap.set('41330', 'Villanueva del Río y Minas');
        this.codigosPostalesMap.set('41330', 'Tocina');
        this.codigosPostalesMap.set('41339', 'Carmona');
        this.codigosPostalesMap.set('41340', 'Tocina');
        this.codigosPostalesMap.set('41350', 'Villanueva del Río y Minas');
        this.codigosPostalesMap.set('41359', 'Villanueva del Río y Minas');
        this.codigosPostalesMap.set('41360', 'El Pedroso');
        this.codigosPostalesMap.set('41370', 'Cazalla de la Sierra');
        this.codigosPostalesMap.set('41380', 'Alanís');
        this.codigosPostalesMap.set('41388', 'San Nicolás del Puerto');
        this.codigosPostalesMap.set('41389', 'San Nicolás del Puerto');
        this.codigosPostalesMap.set('41390', 'Guadalcanal');
        this.codigosPostalesMap.set('41400', 'Écija');
        this.codigosPostalesMap.set('41409', 'Écija');
        this.codigosPostalesMap.set('41410', 'Carmona');
        this.codigosPostalesMap.set('41420', 'Fuentes de Andalucía');
        this.codigosPostalesMap.set('41429', 'La Campana');
        this.codigosPostalesMap.set('41430', 'La Luisiana');
        this.codigosPostalesMap.set('41439', 'La Luisiana');
        this.codigosPostalesMap.set('41439', 'Ca?ada Rosal');
        this.codigosPostalesMap.set('41439', 'Fuentes de Andalucía');
        this.codigosPostalesMap.set('41440', 'Alcolea del Río');
        this.codigosPostalesMap.set('41440', 'Lora del Río');
        this.codigosPostalesMap.set('41449', 'Alcolea del Río');
        this.codigosPostalesMap.set('41450', 'Constantina');
        this.codigosPostalesMap.set('41460', 'Las Navas de la Concepción');
        this.codigosPostalesMap.set('41470', 'Pe?aflor');
        this.codigosPostalesMap.set('41470', 'La Puebla de los Infantes');
        this.codigosPostalesMap.set('41471', 'Utrera');
        this.codigosPostalesMap.set('41479', 'La Puebla de los Infantes');
        this.codigosPostalesMap.set('41489', 'Aznalcázar');
        this.codigosPostalesMap.set('41500', 'Alcalá de Guadaíra');
        this.codigosPostalesMap.set('41510', 'Mairena del Alcor');
        this.codigosPostalesMap.set('41520', 'El Viso del Alcor');
        this.codigosPostalesMap.set('41520', 'Alcalá de Guadaíra');
        this.codigosPostalesMap.set('41530', 'Morón de la Frontera');
        this.codigosPostalesMap.set('41540', 'La Puebla de Cazalla');
        this.codigosPostalesMap.set('41550', 'Aguadulce');
        this.codigosPostalesMap.set('41560', 'Estepa');
        this.codigosPostalesMap.set('41563', 'Écija');
        this.codigosPostalesMap.set('41564', 'Lora de Estepa');
        this.codigosPostalesMap.set('41565', 'Gilena');
        this.codigosPostalesMap.set('41566', 'Pedrera');
        this.codigosPostalesMap.set('41567', 'Herrera');
        this.codigosPostalesMap.set('41567', 'Écija');
        this.codigosPostalesMap.set('41568', 'El Rubio');
        this.codigosPostalesMap.set('41569', 'Marinaleda');
        this.codigosPostalesMap.set('41570', 'Badolatosa');
        this.codigosPostalesMap.set('41580', 'Casariche');
        this.codigosPostalesMap.set('41590', 'La Roda de Andalucía');
        this.codigosPostalesMap.set('41599', 'La Roda de Andalucía');
        this.codigosPostalesMap.set('41599', 'Badolatosa');
        this.codigosPostalesMap.set('41600', 'Arahal');
        this.codigosPostalesMap.set('41610', 'Paradas');
        this.codigosPostalesMap.set('41620', 'Marchena');
        this.codigosPostalesMap.set('41630', 'Lantejuela');
        this.codigosPostalesMap.set('41640', 'Osuna');
        this.codigosPostalesMap.set('41650', 'El Saucejo');
        this.codigosPostalesMap.set('41657', 'Los Corrales');
        this.codigosPostalesMap.set('41658', 'Martín de la Jara');
        this.codigosPostalesMap.set('41659', 'El Saucejo');
        this.codigosPostalesMap.set('41660', 'Villanueva de San Juan');
        this.codigosPostalesMap.set('41661', 'Algámitas');
        this.codigosPostalesMap.set('41670', 'Pruna');
        this.codigosPostalesMap.set('41700', 'Dos Hermanas');
        this.codigosPostalesMap.set('41701', 'Dos Hermanas');
        this.codigosPostalesMap.set('41702', 'Dos Hermanas');
        this.codigosPostalesMap.set('41703', 'Dos Hermanas');
        this.codigosPostalesMap.set('41704', 'Dos Hermanas');
        this.codigosPostalesMap.set('41710', 'Utrera');
        this.codigosPostalesMap.set('41719', 'Utrera');
        this.codigosPostalesMap.set('41720', 'Utrera');
        this.codigosPostalesMap.set('41720', 'Los Palacios y Villafranca');
        this.codigosPostalesMap.set('41727', 'Los Palacios y Villafranca');
        this.codigosPostalesMap.set('41727', 'Utrera');
        this.codigosPostalesMap.set('41728', 'Utrera');
        this.codigosPostalesMap.set('41728', 'Los Palacios y Villafranca');
        this.codigosPostalesMap.set('41728', 'Dos Hermanas');
        this.codigosPostalesMap.set('41729', 'Las Cabezas de San Juan');
        this.codigosPostalesMap.set('41730', 'Cazalla de la Sierra');
        this.codigosPostalesMap.set('41730', 'Las Cabezas de San Juan');
        this.codigosPostalesMap.set('41740', 'Lebrija');
        this.codigosPostalesMap.set('41749', 'El Cuervo de Sevilla');
        this.codigosPostalesMap.set('41750', 'Los Molares');
        this.codigosPostalesMap.set('41760', 'El Coronil');
        this.codigosPostalesMap.set('41770', 'Montellano');
        this.codigosPostalesMap.set('41780', 'Coripe');
        this.codigosPostalesMap.set('41800', 'Sanlúcar la Mayor');
        this.codigosPostalesMap.set('41804', 'Olivares');
        this.codigosPostalesMap.set('41805', 'Benacazón');
        this.codigosPostalesMap.set('41806', 'Umbrete');
        this.codigosPostalesMap.set('41807', 'Espartinas');
        this.codigosPostalesMap.set('41808', 'Villanueva del Ariscal');
        this.codigosPostalesMap.set('41809', 'Albaida del Aljarafe');
        this.codigosPostalesMap.set('41810', 'Castilleja del Campo');
        this.codigosPostalesMap.set('41820', 'Carrión de los Céspedes');
        this.codigosPostalesMap.set('41830', 'Huévar del Aljarafe');
        this.codigosPostalesMap.set('41840', 'Pilas');
        this.codigosPostalesMap.set('41849', 'Aznalcázar');
        this.codigosPostalesMap.set('41850', 'Villamanrique de la Condesa');
        this.codigosPostalesMap.set('41860', 'Gerena');
        this.codigosPostalesMap.set('41870', 'Aznalcóllar');
        this.codigosPostalesMap.set('41880', 'El Ronquillo');
        this.codigosPostalesMap.set('41888', 'El Garrobo');
        this.codigosPostalesMap.set('41888', 'San Nicolás del Puerto');
        this.codigosPostalesMap.set('41889', 'El Castillo de las Guardas');
        this.codigosPostalesMap.set('41890', 'El Castillo de las Guardas');
        this.codigosPostalesMap.set('41897', 'El Madro?o');
        this.codigosPostalesMap.set('41898', 'El Madro?o');
        this.codigosPostalesMap.set('41898', 'El Castillo de las Guardas');
        this.codigosPostalesMap.set('41899', 'El Castillo de las Guardas');
        this.codigosPostalesMap.set('41900', 'Camas');
        this.codigosPostalesMap.set('41907', 'Valencina de la Concepción');
        this.codigosPostalesMap.set('41908', 'Castilleja de Guzmán');
        this.codigosPostalesMap.set('41909', 'Salteras');
        this.codigosPostalesMap.set('41910', 'Camas');
        this.codigosPostalesMap.set('41920', 'San Juan de Aznalfarache');
        this.codigosPostalesMap.set('41926', 'Mairena del Aljarafe');
        this.codigosPostalesMap.set('41927', 'Mairena del Aljarafe');
        this.codigosPostalesMap.set('41928', 'Palomares del Río');
        this.codigosPostalesMap.set('41929', 'Mairena del Aljarafe');
        this.codigosPostalesMap.set('41930', 'Bormujos');
        this.codigosPostalesMap.set('41940', 'Tomares');
        this.codigosPostalesMap.set('41950', 'Castilleja de la Cuesta');
        this.codigosPostalesMap.set('41960', 'Gines');
        this.codigosPostalesMap.set('41970', 'Santiponce');
        this.codigosPostalesMap.set('41980', 'La Algaba');
        this.codigosPostalesMap.set('41989', 'La Algaba');
      }
}
